import React from 'react';
import { BillingPortalStateContext } from '../providers/BillingPortalStateProvider';
import { getCookieFlag, LoadingStates } from '@zg-rentals/rental-manager-env';
import { TEST_DATA } from '../pages/GuestPay/testData';
import type { PaymentType } from '../model/PaymentType';
import type {
  AdproductsGuestPayZuoraDto,
  AdproductsUserMetroidAlicornPaymentResultDto,
} from '@zg-rentals/ts-adproducts-client';

export interface BillingPortalGuestPayState {
  accountHasAccessToInvoices: boolean;
  guestPaySessionKey: string;
  invoices: Array<AdproductsGuestPayZuoraDto>;
  guestPayLoadingSessionState: LoadingStates;
  selectedInvoices: Set<string>;
  primaryInvoice?: string;
  accountNumber?: string;
  paymentMethodId?: string;
  paymentType?: PaymentType;
  paymentResults?: Record<string, AdproductsUserMetroidAlicornPaymentResultDto>;
}

const initializeState = (): BillingPortalGuestPayState => ({
  accountHasAccessToInvoices: false,
  guestPaySessionKey: '-',
  invoices: [],
  guestPayLoadingSessionState: LoadingStates.INITIAL,
  selectedInvoices: new Set(),
});

export const useGuestPay = () => {
  const [guestPayState, setGuestPayState] = React.useState<BillingPortalGuestPayState>(
    getCookieFlag('ZG_ENABLE_GUEST_PAY_TEST_DATA') ? TEST_DATA : initializeState(),
  );

  const updateGuestPayState = React.useCallback(
    (newState: Partial<BillingPortalGuestPayState>) => {
      setGuestPayState((existingState) => ({
        ...existingState,
        ...newState,
      }));
    },
    [setGuestPayState],
  );

  const initializeGuestPay = () => {
    setGuestPayState(initializeState());
  };

  return {
    guestPayState,
    updateGuestPayState,
    initializeGuestPay,
  };
};

export const useAppGuestPay = () => {
  const billingPortalState = React.useContext(BillingPortalStateContext);

  if (!billingPortalState) throw new Error('State Not initialized');

  return billingPortalState.guestPayState;
};
